import { client } from 'lib/evi-api-gateway';

const url = `${process.env.REACT_APP_API_URL_RESOURCE}/api/school`;

//获取数据列表
export async function getClassList() {
  return client.post({
    url: `${url}/get_class_list`
  });
}

// 获取教职工列表
export async function staffList(params: any) {
  return client.post({
    url: `${url}/school/get_staff_list`,
    form: { ...params }
  });
}

function gradeChange(region: any, grade: any) {
  if (region === 'my') {
    switch (grade) {
      case 'PN':
        return 'N1';
      case 'K1':
        return 'N2';
      case 'K2':
        return 'K1';
      case 'K3':
        return 'K2';
      default:
        return grade;
    }
  }
  return grade;
}

export async function getClassTree(region = 'hk') {
  return getClassList()
    .then((ret) => ret.rows)
    .catch((err) => [])
    .then((gList) => {
      let _ret = gList.reduce(
        (
          _list: any,
          { grade_id, year_name, grade_name, class_name, grade_type, class_id }: any
        ) => {
          const gradeType = gradeChange(region, grade_type);

          if (!_list[grade_type]) {
            _list[grade_type] = {
              label: `${gradeType}`,
              value: `${grade_type}`,
              key: `${grade_type}`,
              children: []
            };
          }
          if (!_list[grade_type].children[grade_id]) {
            _list[grade_type].children[grade_id] = {
              label: `${year_name} ${grade_name}`,
              value: `${grade_type}-${grade_id}`,
              key: `${grade_type}-${grade_id}`,
              children: []
            };
          }
          _list[grade_type].children[grade_id].children.push({
            label: `${class_name}`,
            value: `${grade_type}-${grade_id}-${class_id}`,
            key: `${grade_type}-${grade_id}-${class_id}`
          });
          return _list;
        },
        {}
      );
      (Object.keys(_ret) || []).map((_gType) => {
        _ret[_gType].children = Object.values(_ret[_gType].children);
        return true;
      });
      return { classTree: Object.values(_ret), classList: gList };
    });
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getClassList,
  getClassTree
};
